import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentMethodsMovementModalComponent } from './payment-methods-movement-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [PaymentMethodsMovementModalComponent],
  imports: [
    CommonModule,
    NgSelectModule,
    FormsModule
  ],
  exports: [PaymentMethodsMovementModalComponent]
})
export class PaymentMethodsMovementModalModule { }